/**
 * WordPress dependencies
 */
export * from '@wordpress/i18n';
